export enum VbSpinnerType {
	BUFFERING = 'Buffering',
	INITIAL = 'Initial'
}
